import { useRef } from 'react'
import { useButton } from 'react-aria'

interface IconButtonProps {
	label: string
	onPress: () => void
	isDisabled?: boolean
	className?: string
	children: React.ReactNode
}

export function IconButton({ label, onPress, isDisabled, className, children }: IconButtonProps) {
	const ref = useRef<HTMLButtonElement>(null)
	const { buttonProps } = useButton({ onPress, isDisabled, 'aria-label': label }, ref)

	return (
		<button ref={ref} {...buttonProps} className={className} title={label}>
			{children}
		</button>
	)
}
